import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HOC as FormsyHOC } from 'formsy-react';

import { FormsyCheckbox as Checkbox } from 'formsy-material-ui';
import { List, ListItem } from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import { formatName } from '../../utils/StringUtils';

/**
 *
 * MultiCheckboxSet
 *
 * Group of checkbox elements
 *
 * @prop string title, list subheader
 * @prop string name, name of the form field
 * @prop array items, collection of selectable items
 * @prop array value, selected checkboxes
 */
class MultiCheckboxSet extends Component {

    componentDidMount() {
        this.props.setValue(this.props.value);
        this.forceUpdate();
    }

    render() {
        const { title, name, items, disabled } = this.props;
        const values = this.props.getValue();
        return (
            <List name={name} >
                <Subheader inset={true}>{title}</Subheader>
                {items
                    .map(i => (typeof i === 'string' || typeof i === 'number') ? {id: i, name: i} : i)
                    .map((item, i) => (
                        <ListItem
                            key={i}
                            primaryText={item.name || formatName(item)}
                            leftCheckbox={
                            <Checkbox
                                name={`_multicheckbox_${name}[${item.id}]`}
                                defaultChecked={values.includes(item.id)}
                                value={values.includes(item.id)}
                                onChange={this.setValue.bind(this, item.id)}
                                disabled={disabled}
                            />}
                        />
                    ))}
            </List>
        );
    }

    setValue(value, { target, currentTarget }) {
        const values = this.props.getValue();
        let newValues;
        if (target.checked !== values.includes(value)) {
            if (target.checked) {
                newValues = [...values, value];
            } else {
                newValues = values.filter(v => v !== value);
            }
        }
        this.props.setValue(newValues);
    }
}

MultiCheckboxSet.propTypes = {
    title: PropTypes.string,
    name: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.object),
    value: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.number),
        PropTypes.arrayOf(PropTypes.string),
        PropTypes.arrayOf(PropTypes.bool),
        PropTypes.arrayOf(PropTypes.object)
    ]),

    required: PropTypes.bool,
    disabled: PropTypes.bool,
};

MultiCheckboxSet.defaultProps = {
    disabled: false
};

export default FormsyHOC(MultiCheckboxSet);
